import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuard } from './services/auth-guard.service';
import { GuestAuthGuard } from './services/guest-guard.service';
import { RoleGuard } from './services/role-guard.service';
import { Role } from './data-models/role';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login/simple',
  },
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'vendor',
        data: { roles: [Role.SAdmin, Role.Admin, Role.PP, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/vendor/vendor.module#VendorModule'
      },
      {
        path: 'search',
        data: { roles: [Role.PP, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/search/search.module#SearchModule'
      },
      {
        path: 'message-center',
        data: { roles: [Role.PP, Role.VAdmin, Role.DAdmin, Role.VUser] },
        canActivate: [RoleGuard],
        loadChildren: './modules/message-center/message-center.module#MessageCenterModule'
      },
      {
        path: 'users',
        data: { roles: [Role.SAdmin, Role.Admin, Role.VAdmin, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/users/users.module#UsersModule'
      },
      {
        path: 'technician',
        data: { roles: [Role.SAdmin, Role.Admin, Role.PP, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/technician/technician.module#TechnicianModule'
      },

      {
        path: 'lookupTypes',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/lookup-types/lookup-types.module#LookupTypesModule'
      },
      {
        path: 'lookup',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/lookup-types/lookup/lookup.module#LookupModule'
      },
      {
        path: 'configuration',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/configuration/configuration.module#ConfigurationModule'
      },

      {
        path: 'products',
        data: { roles: [Role.VAdmin, Role.VUser, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/products/products.module#ProductsModule'

      },
      {
        path: 'profile',
        loadChildren: './modules/profile/profile.module#ProfileModule'
      },
      {

        path: 'emailTemplates',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/email-templates/email-templates.module#EmailTemplatesModule'
      },
      {
        path: 'shoppingcart',
        data: { roles: [Role.PP, Role.DAdmin, Role.SAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/shoppingcart/shoppingcart.module#ShoppingcartModule'
      },
      {
        path: 'rfqs',
        data: { roles: [Role.VAdmin, Role.VUser, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/rfqs/rfqs.module#RfqsModule'
      },
      {
        path: 'menu',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/menus/menus.module#MenusModule'
      },
      {
        path: 'role-menu-mapping',
        data: { roles: [Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/role-menu-mapping/role-menu-mapping.module#RoleMenuMappingModule'
      },
      {
        path: 'purchase-order',
        data: { roles: [Role.VAdmin, Role.VUser, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/po/po.module#PoModule'
      },
      {
        path: 'pprfqs',
        data: { roles: [Role.PP, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/pprfq/pprfq.module#PprfqModule'
      },
      {
        path: 'pp-purchase-order',
        data: { roles: [Role.PP, Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/pppo/pppo.module#PppoModule'
      },
      {
        path: 'point-to-point',
        data: { roles: [Role.VAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/point-to-point/point-to-point.module#PointToPointModule'
      },
      {
        path: 'equipment-management',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/equipment-management/equipment-management.module#EquipmentManagementModule'

      },
      {
        path: 'cart-management',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-cart-management/uptime-cart-management.module#UptimeCartManagementModule'
      },

      {
        path: 'uptime-customers',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-customers/uptime-customers.module#UptimeCustomersModule'
      },
      {
        path: 'uptime-rfq',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-rfq/uptime-rfq.module#UptimeRFQModule'
      },
      {
        path: 'uptime-orders',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-orders/uptime-orders.module#UptimeOrdersModule'
      },
      {
        path: 'uptime-business-licensee',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-business-licensee/uptime-business-licensee.module#UptimeBusinessLicenseeModule'
      },
      {
        path: 'uptime-sellers',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-sellers/uptime-sellers.module#UptimeSellersModule'
      },
      {
        path: 'uptime-manufacturers',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-manufacturers/uptime-manufacturers.module#UptimeManufacturersModule'
      },
      {
        path: 'uptime-enquiry',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-subscription-enquiry/uptime-subscription-enquiry.module#UptimeSubscriptionEnquiryModule'
      },
      {
        path: 'uptime-selling',
        data: { title: 'Selling', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/uptime-selling/uptime-selling.module#UptimeSellingModule'
      },
      {
        path: 'equipment-nft',
        data: { title: 'Equipment NFT', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/equipment-nft/equipment-nft.module#EquipmentNFTModule'
      },
      {
        path: 'share-trading',
        data: { title: 'NFT Share Trading', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/eqpnft-share-trading/nft-share-trading.module#NFTShareTradingModule'
      },
      {
        path: 'subscription',
        data: { title: 'Subscription', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/subscription/subscription.module#SubscriptionModule'
      },
      {
        path: 'site',
        data: { title: 'Sites', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/sites/sites.module#SitesModule'
      },
      {
        path: 'terms-conditions',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/terms-conditions/terms-conditions.module#TermsCondtionsModule'
      },
      {
        path: 'wallet',
        data: { title: 'Wallet', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/wallet/wallet.module#WalletModule'
      },
      {
        path: 'selling-payment',
        data: { title: 'Selling Payments', roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/selling-payment/selling-payment.module#SellingPaymentModule'
      },
      {
        path: 'promotion',
        data: { roles: [Role.UpAdmin,  Role.DAdmin] },
        canActivate: [RoleGuard],
        loadChildren: './modules/promotion/promotion.module#PromotionModule'
      },
    ]
  },
  {
    path: '',
    component: AuthComponent,
    canActivate: [GuestAuthGuard],
    children: [
      {
        path: 'auth',
        loadChildren: './modules/auth/auth.module#AuthModule'
      }
    ]
  }

  // {
  //   path: '**',
  //   component: PageNotFoundComponent
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
